module.exports = __webpack_public_path__ + "static/img/owner.29eb6da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/owner.png
// module id = 176
// module chunks = 6